/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Shopify injects the standard-actions bundle via `content_for_header`, which
// sits after snippets/scripts.liquid in <head>, so `Shopify.actions` is never
// attached yet when this module body runs. DOMContentLoaded fires after both.
document.addEventListener('DOMContentLoaded', init, { once: true });
